export const getScript = (script) => {
    return script ? script : [];
}
